module.exports = __webpack_public_path__ + "static/media/medal.1a923a7d.svg";